;(function (site, undefined) {
	"use strict"

	site.ytPlayer = {
		$player: null,

		init: function () {
			this.$player = $('.yt-player')

			if ( this.$player.length ) {
				this.eventHandlers()
			}
		},

		eventHandlers: function () {
			var $play = this.$player.find('.yt-player__play')

			if ( $play.length ) {
				$play.click(function(e) {
					e.preventDefault()

					var $poster = $(this).siblings('.yt-player__poster')
					var $video = $(this).siblings('.yt-player__video')

					$(this).hide()
					$poster.length && ( $poster.hide() )
					$video.length && ( $video[0].src += "?mute=1&autoplay=1" )
				})
			}
		}
	}
})(window.site = window.site || {})